import { StepProps } from "@/components/onboarding/components/ImportWizard";
import {
  FooterButtons,
  FooterContainer,
  SkipLink,
  StepTitle,
  WizardContentWrapper,
} from "@/components/onboarding/components/ImportWizard/StyledComponents";
import type { StepMap } from "@/components/onboarding/components/ImportWizard/ImportWizard.types";
import { DropTargetStep } from "@/components/onboarding/components/ImportWizard/steps/DropTargetStep";

const OtherAppsStep1: React.FC<StepProps> = ({ onClose, onSkip }) => (
  <WizardContentWrapper>
    <StepTitle>
      Bring in your notes so you can find them with Mem Search, Chat, and Copilot
    </StepTitle>

    <DropTargetStep
      onDrop={() => {
        onClose?.();
      }}
    />

    <FooterContainer>
      <FooterButtons>
        <div>&nbsp;</div>
        <SkipLink onClick={onSkip}>Skip for now</SkipLink>
      </FooterButtons>
    </FooterContainer>
  </WizardContentWrapper>
);

export const OtherAppsStepsMap: StepMap = {
  "other-apps-1": {
    render: ({ onNavToStep, onClose, onSkip }) => (
      <OtherAppsStep1 onNavToStep={onNavToStep} onClose={onClose} onSkip={onSkip} />
    ),
  },
};
